import classNames from "classnames";
import { forwardRef, InputHTMLAttributes } from "react";

import {
  CheckboxContainer,
  CheckboxIcon,
  CheckboxWrapper,
  HiddenCheckbox,
  LabelText,
  StyledCheckbox
} from "./Checkbox.styled";

import { paths } from "src/assets/styles/settings";
import { PropsWithDataQaid } from "src/types/componentProps";

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> &
  PropsWithDataQaid<{
    /**
     * Set checkbox to be checked
     * @default {false}
     */
    checked?: boolean;

    /**
     * Set checkbox to be disabled
     * @default {false}
     */
    disabled?: boolean;

    /**
     * label className
     */
    labelClassName?: string;
  }>;

const defaultProps = {
  checked: false,
  disabled: false
};

const Checkbox = forwardRef<HTMLLabelElement, CheckboxProps>((props, ref) => {
  const { className, children, checked, disabled, "data-qaid": dataQaid, labelClassName, ...restProps } = props;
  const checkboxClass = classNames("c-checkbox", className);

  return (
    <CheckboxWrapper data-testid="qa-checkbox" ref={ref} data-qaid={dataQaid} className={checkboxClass}>
      <CheckboxContainer className="c-checkbox__wrapper">
        <HiddenCheckbox
          data-testid="qa-checkbox-input"
          className="c-checkbox__input"
          checked={checked}
          disabled={disabled}
          data-qaid={`${dataQaid}-input`}
          {...restProps}
        />
        <StyledCheckbox data-testid="qa-checkbox-box" className="c-checkbox__box">
          <CheckboxIcon data-testid="qa-checkbox-icon" className="c-checkbox__icon" viewBox="0 0 24 24">
            <path d={paths.check_icon} />
          </CheckboxIcon>
        </StyledCheckbox>
      </CheckboxContainer>
      <LabelText className={labelClassName} disabled={disabled}>
        {children}
      </LabelText>
    </CheckboxWrapper>
  );
});

Checkbox.defaultProps = defaultProps;

export default Checkbox;
